import React from 'react'
import { Card, Row, Col, Skeleton } from 'antd'

const SkeletonCard = () => {
    return (
        <div className="daimondsCard">
            <div>
                <Card
                className='daimondsCard skeleton-prod-card'
                    hoverable
                    style={{ margin: '10px', background: 'transparent' }}
                    cover={
                        <div className='prd-images'>
                            <Skeleton.Image block={true} style={{width: '100%'}} active={true} />
                        </div>
                    }
                >
                    <Skeleton rows={2} />
                </Card>
            </div>
        </div>
    )
}

const SkeletonProd = () => {
    return (
        <Row gutter={[20, 20]}>
            {Array.from([0, 1, 2, 3, 4, 5, 6, 7]).map((prod, index) => {
                return (
                    <Col
                        key={index} // Add a unique key for each item
                        xs={24}    // Full width on extra small screens (1 column)
                        sm={12}    // Half width on small screens (2 columns)
                        md={8}     // One-third width on medium screens (3 columns)
                        lg={6}     // One-fourth width on large screens (4 columns)
                        xl={6}     // One-fourth width on extra large screens (4 columns)
                    >
                        <SkeletonCard />
                    </Col>
                );
            })}
        </Row>
    )
}

export default SkeletonProd
